// extracted by mini-css-extract-plugin
export default {"container":"styles_container__M8b0H","title":"styles_title__h4qjG","description":"styles_description__iBYSY","buttonContainer":"styles_buttonContainer__iApR0"};